export default "__VITE_ASSET__ad09f45d__"